<template>
  <div class="main">
    <GroupSelector 
      v-model="selectedPool" 
      :pools="pools" 
      @change="poolChanged()"
    />
    <h1 class="page-title">Abgegebene Votes</h1>
    <div v-if="!loading && (!this.pools || this.pools.length === 0)" class="center-msg">
      <h3>Du bist noch kein Mitglied in einer Gruppe!</h3>
      <p>Tritt auf der Startseite zuerst einer Gruppe bei.</p>
    </div>
    <div v-if="!loading && this.pools && this.pools.length > 0 && (!this.votes || this.votes.length === 0)" class="center-msg">
      <h3>Du hast noch keine Votes abgegeben.</h3>
    </div>
    <ProfilePreview
      v-if="selectedProfileId"
      :profile_id="selectedProfileId"
      :show-vote-action="true"
      :initial-liked="selectedVote ? selectedVote.liked : null"
      @close="selectProfile(null)"
      @vote-changed="onVoteChanged"
    ></ProfilePreview>
    <div class="vote-list">
      <div class="vote" v-for="vote in votes" :key="vote.id" @click="selectProfile(vote)">
        <div class="profile-info">
          <h2>{{vote.name}}</h2>
          <div class="profile-stat">
            <img src="@/assets/images/search.svg">
            <p>{{vote.looking_for}}</p>
          </div>
        </div>
        <div class="like-status" :class="{liked: vote.liked === 1, disliked: vote.liked !== 1}">
          <img :src="vote.liked === 1 ? checkIcon : crossIcon">
        </div>
      </div>
    </div>
    <LoadingSpinner  v-if="loading" message="Votes werden geladen..." class="center-msg"/>
  </div>
</template>

<script>
import AuthService from '@/services/AuthService.js';
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import ProfilePreview from "@/components/ProfilePreview.vue";
import GroupSelector from "@/components/GroupSelector.vue";
import checkIcon from '@/assets/images/check.svg';
import crossIcon from '@/assets/images/cross.svg';

export default {
  "name": "VoteOverview",
  data() {
    return {
      user: null,
      isAdmin: false,
      votes: null,
      selectedPool: null,
      pools: null,
      loading: false,
      selectedProfileId: null,
      selectedVote: null,
      checkIcon,
      crossIcon
    }
  },
  components: {
    LoadingSpinner,
    ProfilePreview,
    GroupSelector
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
      this.$router.push('/login');
    },
    poolChanged() {
      this.votes = null
      this.selectedProfileId = null
      this.selectedVote = null
      this.getVotes()
      try {
        AuthService.updateSelectedPool({selected_pool: this.selectedPool.id})
        this.$store.dispatch('updateLastSelectedPool', {pool_id: this.selectedPool.id})
      } catch(e) {
        console.error(e)
      }
    },
    selectProfile(vote){
      this.$nextTick(() => {
        this.selectedVote = vote
        this.selectedProfileId = vote ? vote.target_id : null
      })
    },
    onVoteChanged() {
      this.getVotes()
    },
    async getVotes() {
      this.loading = true
      if(this.selectedPool?.id) {
        let msg = await AuthService.getUserVotes({pool_id: this.selectedPool.id})
        if(msg.success){
          this.votes = msg.msg
        } else {
          console.error(msg)
        }
      }

      this.loading = false
    },
    async getUserJoinedPools() {
      this.loading = true

      try {
        this.msg = await AuthService.getUserJoinedPools()
        if (this.msg.success && this.msg.msg.length > 0) {
          this.pools = this.msg.msg
          this.selectedPool = this.msg.msg.find(res => res.id === this.user.last_selected_pool) || this.msg.msg[0]
        }
      } catch (e) {
        console.error(e)
        this.errorMsg = e.response.data.msg
      }

      this.loading = false
    },
  },
  async beforeCreate() {
    if (!this.$store.getters.isLoggedIn) {
      this.$router.push('/login');
    }
  },
  async mounted() {
    try {
      this.msg = await AuthService.getUser()
      this.isAdmin = !!this.msg.msg[0].isAdmin;
      this.user = this.msg.msg[0]
    } catch(e){
      console.error(e)
    }

    await this.getUserJoinedPools()
    await this.getVotes()
  }
}
</script>
<style scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  padding-top: 20px;
}

.page-title {
  font-size: 2rem;
  font-weight: 800;
  letter-spacing: -0.02em;
  margin: 24px 0;
  color: var(--text-on-gradient);
}

/* Selector */
.select-container {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--glass-bg);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  padding: 8px 16px;
  border-radius: var(--radius-xl);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-soft);
}

.selected-pool {
  font-size: 1rem;
  font-weight: 600;
  font-family: var(--font);
  background: none;
  border: none;
  color: var(--text-main);
  outline: none;
  cursor: pointer;
  -webkit-appearance: none;
  appearance: none;
}

.select-container img {
  width: 14px;
  transform: rotate(-90deg);
  opacity: 0.5;
}

/* Vote List */
.vote-list {
  width: 100%;
  max-width: var(--max-width);
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 0 20px 40px;
  box-sizing: border-box;
  overflow-y: auto;
}

.vote {
  background: white;
  border-radius: var(--radius-l);
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--shadow-soft);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.vote:active {
  transform: scale(0.98);
}

.vote .profile-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  cursor: pointer;
  flex: 1;
}

.vote h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}

.profile-stat {
  display: flex;
  align-items: center;
  gap: 6px;
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.profile-stat p {
  margin: 0;
}

.profile-stat img {
  width: 14px;
  opacity: 0.5;
}

.like-status {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.like-status.liked {
  background: #E8F5E9;
}

.like-status.disliked {
  background: #FFEBEE;
}

.like-status img {
  width: 16px;
}

.like-status.liked img {
  filter: invert(48%) sepia(70%) saturate(400%) hue-rotate(80deg) brightness(95%) contrast(90%);
}

.like-status.disliked img {
  filter: invert(30%) sepia(80%) saturate(2000%) hue-rotate(330deg) brightness(100%) contrast(100%);
}
</style>
